module.exports = __webpack_public_path__ + "static/instagram-86f33cfc1e9c3bc689abc0851fa2f7b5.png";